import { Button } from '@/components/ui/button';

interface SessionGateScreenProps {
  onRetry: () => void;
}

export function SessionGateScreen({ onRetry }: SessionGateScreenProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="flex w-full max-w-sm flex-col items-center gap-4 text-center">
        <h1 className="text-xl font-semibold text-slate-900">We couldn't check your session</h1>
        <p className="text-sm text-slate-600">
          The server did not respond as expected. Check your connection and try again.
        </p>
        <Button onClick={onRetry}>Try again</Button>
      </div>
    </div>
  );
}
